/**
 * The columns to offer for rows an owner manages after publishing, learned from the rows that
 * exist.
 *
 * These collections are declared with no fixed fields on purpose — the owner may add a column
 * later and a declared list would start refusing the very rows the edit added — so the shape is
 * whatever the rows already have. An empty collection has nothing to learn from, which is why
 * `addManagedRow` takes whatever the caller gives it.
 *
 * Its own module, with no imports, so the web builder can share it (web/src/__tests__/
 * boundary.test.ts lists it as pure) rather than keep a copy: managedRows.ts, the phone's client,
 * reaches CognitoService and so React Native. Two copies of which columns an owner may edit is
 * two answers to one question.
 */
export function columnsOf(rows: readonly Record<string, unknown>[]): string[] {
  const out: string[] = [];
  for (const row of rows) {
    for (const key of Object.keys(row)) {
      if (key !== 'id' && key !== 'createdAt' && key !== 'updatedAt' && !out.includes(key)) out.push(key);
    }
  }
  return out;
}
